module.exports = __webpack_public_path__ + "static/media/form-sent.1e4b04e5.png";